import { render } from "./ReadySendBox.vue?vue&type=template&id=1df5aa1a&ts=true"
import script from "./ReadySendBox.vue?vue&type=script&lang=ts"
export * from "./ReadySendBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__